'use client';

import { useEffect, useState } from 'react';

import { ScriptsHandlerProps } from './types';

const ScriptHandler = ({ children }: ScriptsHandlerProps) => {
  const [userInteractive, setUserInteractive] = useState(false);

  const userInteractHandler = () => {
    /*
      in order to improve INP we have to move this function into
      separate micro task by using setTimeout in order to reduce TBT
    */
    setTimeout(() => {
      setUserInteractive(true);
    }, 0);
  };

  useEffect(() => {
    if (!userInteractive) {
      window.addEventListener('mousedown', userInteractHandler);
      window.addEventListener('scroll', userInteractHandler);
    } else {
      window.removeEventListener('mousedown', userInteractHandler);
      window.removeEventListener('scroll', userInteractHandler);
    }
  }, [userInteractive]);

  return typeof window !== 'undefined' && userInteractive ? children : null;
};

export default ScriptHandler;
